<template lang="pug">
  .shaft-text(ref="root")
</template>
<script setup lang="ts">
import { computed, onMounted, useTemplateRef, watch } from 'vue'
import { renderShaftText } from '@zeus'
import { useRogue } from '@/js/services/Rogue'

const props = defineProps<{
  options: Parameters<typeof renderShaftText>[0],
}>()

const rogue = useRogue()
const root = useTemplateRef<HTMLElement>('root')

const renderKey = computed(() => [
  props.options.shaftText.val,
  props.options.shaftColor.val,
  props.options.shaftFont.val,
].join(''))

async function update() {
  if (!root.value) {
    return
  }

  const el = root.value.children?.[0] as HTMLElement | undefined
  const { svg } = await renderShaftText(props.options, document, rogue.fetch.bind(rogue), el)

  if (!root.value.children.length) {
    root.value.appendChild(svg)
  }
}

watch(renderKey, () => {
  if (root.value) {
    update()
  }
})

onMounted(() => {
  setTimeout(() => update(), 100)
})
</script>
